import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    getFilterItem: ({ rootGetters }) => {
        let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];
        let query = {};

        Object.keys(getFilterItem).forEach((key) => {
            if (getFilterItem[key].length > 0) {
                switch (key) {
                    // Filter Invoice
                    case "statusGaji":
                        query.status_invoice_array = getFilterItem[key];
                        break;
                    case "jenisPembayaran":
                        query.jenis_pembayaran_array = getFilterItem[key];
                        break;
                    case "outlet":
                        query.idoutlet_array = getFilterItem[key];
                        break;
                    // Filter Invoice Add
                    case "jenisTransaksi":
                        query.jenis_transaksi_array = getFilterItem[key];
                        break;
                    case "statusTransaksi":
                        query.status_tahapan_array = getFilterItem[key];
                        break;
                    case "oneOutlet":
                        query.idoutlet_array = [getFilterItem[key]];
                        break;
                    // Filter Invoice  dan Invoice Add
                    case "statusKonfirmasi":
                        query.status_pembayaran_array = getFilterItem[key];
                        break;
                    case "konsumen":
                        query.idkonsumen_array = [];
                        getFilterItem[key].forEach((item) => {
                            query.idkonsumen_array.push(item.id);
                        });
                        break;
                    case "karyawan":
                        query.idkaryawan = getFilterItem[key];
                        break;
                    case "periode_state":
                        query.periode_state = getFilterItem[key];
                        break;
                }
            }
            if (key === "periode") {
                query.filter_by = getFilterItem[key].filterBy;
                if (getFilterItem[key].filterBy === "periode") {
                    query.tanggal_awal = getFilterItem[key].startDate;
                    query.tanggal_akhir = getFilterItem[key].endDate;
                }

                if (getFilterItem[key].filterBy === "tahun") {
                    query.tahun = getFilterItem[key].year;
                }
                if (getFilterItem[key].filterBy === "bulan") {
                    query.bulan = getFilterItem[key].month;
                }
            }
        });

        return query;
    },
    getListInvoice: async ({ commit, dispatch, getters }, { key }) => {
        commit("setResponse", {});
        return new Promise((resolve, reject) => {
            dispatch("getFilterItem")
            .then((filterItem) => {
                let query = {
                    ...filterItem,
                    offset: getters.invoicePage.offset,
                    limit: getters.invoicePage.limit,
                    key,
                };
                conn.get(api.getListInvoice, query).then((res) => {
                    if (!res.data) {
                        commit("setResponse", resulter.errorResult(res));
                    } else {
                        let { code, data, status, msg } = res.data;
                        if (code === 200 && status) {
                            conn.setQueryString(query);
                            commit("setInvoiceList", data);
                            commit("setInvoiceEnd", data.array[data.array.length - 1]);
                            commit("setNextInvoicePage", data.array);
                            commit("setResponse", resulter.successResult(msg));
                        } else {
                            commit("setResponse", resulter.errorResult(msg));
                        }
                    }
                    commit("setLoadMore", false);
                    resolve();
                });
            })
            .catch((e) => {
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
                reject();
            });
        })
    },
    getListKonsumen: ({ commit, getters }, { invoiceId }) => {
        let query = {
            offset: getters.konsumenPage.offset,
            limit: getters.konsumenPage.limit,
        };

        conn.get(`${api.getListKonsumen}/${invoiceId}`, query)
            .then((res) => {
                if (!res.data) {
                    commit("setResponse", resulter.errorResult(res));
                } else {
                    let { code, status, data, msg } = res.data;
                    if (code === 200 && status) {
                        commit("setKonsumenList", data);
                        commit("setKonsumenEnd", data.array[data.array.length - 1]);
                        commit("setNextKonsumenPage", data.array);
                        commit("setResponse", resulter.successResult(msg));
                    }
                }
                commit("setLoadMore", false);
            })
            .catch((e) => {
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDetailInvoice: ({ commit }, { invoiceId }) => {
        commit("setResponse", {});
        conn.get(`${api.getDetailInvoice}/${invoiceId}`)
            .then((res) => {
                if (!res.data) {
                    commit("setResponse", resulter.errorResult(res));
                } else {
                    let { data, status, statusText } = res;
                    if (status === 200) {
                        commit("setInvoiceData", data);
                        commit("setResponse", resulter.successResult(statusText));
                    } else {
                        commit("setResponse", resulter.errorResult(statusText));
                    }
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDataModal: ({ commit }, invoiceId ) => {
        commit("setResponse", {});
        conn.get(`${api.getDataModal}/${invoiceId}`)
            .then((res) => {
                if (res.data.status) {
                    commit("setDataModal", res.data.data);
                } else {
                    commit("setResponse", resulter.errorResult(res));
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListTransaksi: ({ commit, dispatch, getters }) => {
        commit("setResponse", {});
        dispatch("getFilterItem")
            .then((filterItem) => {
                let query = {
                    ...filterItem,
                    offset: getters.transaksiPage.offset,
                    limit: getters.transaksiPage.limit,
                };
                conn.get(api.getListTransaksi, query).then((res) => {
                    if (!res.data) {
                        commit("setResponse", resulter.errorResult(res));
                    } else {
                        let { code, data, status, msg } = res.data;
                        if (code === 200 && status) {
                            let transaksi = data.array !== null ? data.array : [];

                            conn.setQueryString(query);
                            commit("setTransaksiList", data);
                            commit("setTransaksiEnd", transaksi[transaksi.length - 1]);
                            commit("setNextTransaksiPage", transaksi);
                            commit("setResponse", resulter.successResult(msg));
                        } else {
                            commit("setResponse", resulter.errorResult(msg));
                        }
                    }
                    commit("setLoadMore", false);
                });
            })
            .catch((e) => {
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDetailTagihan: (state, { idInvoice }) => {
        return conn.get(`${api.getDetailTagihan}/${idInvoice}`);
    },
    createInvoice: ({ commit }, payload) => {
        let posted = new FormData();
        Object.keys(payload).forEach(function (key) {
            switch (key) {
                case "is_select_all":
                    posted.append(key, payload[key]);
                    break;
                case "pengingat_pelunasan":
                    payload.pengingat_pelunasan.forEach(function (d) {
                        posted.append("pengingat_pelunasan", d);
                    });
                    break;
                case "uncheck_transaksi":
                    if (payload.is_select_all === 1) {
                        payload.uncheck_transaksi.forEach(function (d) {
                            posted.append("id_transaksi", d);
                        });
                    }
                    break;
                case "selected_transaksi":
                    if (payload.is_select_all === 0) {
                        payload.selected_transaksi.forEach(function (d) {
                            posted.append("id_transaksi", d);
                        });
                    }
                    break;
                case "dokumentasi":
                    payload.dokumentasi.forEach(function (d) {
                        posted.append("dokumentasi", d);
                    });
                    break;

                default:
                    if (payload[key]) {
                        if (Array.isArray(payload[key])) {
                            payload[key].forEach((item) => {
                                posted.append(key, item);
                            })
                        }
                        else {
                            posted.append(key, payload[key]);
                        }
                    }
                    break;
            }
        });

        commit("setResponse", {});
        return conn.post(api.createInvoice, posted, conn.contentType.form);
    },
    cancelInvoice: ({ commit }, payload) => {
        let posted = new FormData();
        Object.keys(payload).forEach(function (key) {
            posted.append(key, payload[key]);
        });
        commit("setResponse", {});
        return conn.post(api.cancelInvoice, posted, conn.contentType.form);
    },
    cancelInvoiceLunas: ({ commit }, payload) => {
        commit("setResponse", {});
        return conn.post(api.cancelInvoiceLunas, payload, conn.contentType.json);
    },
    deleteInvoice: ({ commit }, payload) => {
        commit("setResponse", {});
        return conn.post(api.deleteInvoice, payload, conn.contentType.json);
    },
    pembayaranInvoice: ({ commit }, payload) => {
        commit("setResponse", {});
        return conn.post(api.pembayaranInvoice, payload, conn.contentType.form);
    },
    sendWaInvoice: ({ commit }, payload) => {
        commit("setResponse", {});
        let posted = new FormData();
        posted.append('idinvoice', payload)
        return conn.post(`${api.sendWaInvoice}`, posted, conn.contentType.form);
    },
    getDetailPenjadwalan: async ({ commit }, payload) => {
        await conn.get(api.penjadwalan.detail, { idcustomer: payload }).then((res) => {
            if (res.status) {
                commit("setDetailPenjadwalan", res.data.data);
            } else {
                this.$toast.error(resulter.errorResult(res.msg))
            }
        }).catch(e => {
            console.log(e);
            this.$toast.error(resulter.errorResult(e))
        })
    },
    getListPenjadwalan: async ({ commit }, query) => {
        try {
            const res = await conn.get(api.penjadwalan.index, query);
            if (res.status) {;
                if (query.index > 0) {
                    commit("addDataPenjadwalanList", res.data.data);
                }
                else {
                    commit("setPenjadwalanList", res.data);
                }
                commit("setResponse", resulter.successResult(res.msg));
                return resulter.successResult(res.msg)
            } else {
                return resulter.errorResult(res.msg)
            }
        } catch (error) {
            return resulter.errorResult(error)
        }
    },
    createPenjadwalan: async ({ commit }, payload) => {
        try {
            const res = await conn.post(api.penjadwalan.createPenjadwalan, payload, conn.contentType.json)
            if (typeof res === 'string') {
                return resulter.errorResult(res)    
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg) 
            }
            else {
                return resulter.errorResult(res.data.msg)    
            }
        } catch (error) {
            return resulter.errorResult(error)
        }
    },
    updatePenjadwalan: async ({ commit }, payload) => {
        try {
            const res = await conn.post(api.penjadwalan.update, payload, conn.contentType.json)
            if (typeof res === 'string') {
                return resulter.errorResult(res)    
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg) 
            }
            else {
                return resulter.errorResult(res.data.msg)    
            }
        } catch (error) {
            return resulter.errorResult(error)
        }
    },
    deletePenjadwalan: async ({ commit }, payload) => {
        try {
            const res = await conn.del(api.penjadwalan.delete, { idcustomer: payload })
            return resulter.successResult(res.msg)
        } catch (error) {
            console.log(error);
            return resulter.errorResult(error)
        }
    },
    getListKonsumenSchedule: ({commit}, payload ) => {
        try {
            const res = conn.get(api.penjadwalan.listKonsumenSchedule + payload)
            return res
        } catch (error) {
            this.$toast.error(error)
        }
    },
    getCoinEstimation: async ({ commit }) => {
        try {
            const res = await conn.get(api.coupon.mcoin_estimation)
            if (res) {
                commit("setMcoinEstimation", res.data.data)
            }else{
                return resulter.errorResult(res.data.msg) 
            }
            console.log(res)
        } catch (error) {
            return resulter.errorResult(error)
        }
    },
};
